module.exports = __webpack_public_path__ + "img/maximum.6e643074.svg";